import { Container, Col, Row } from "react-bootstrap";
import React, { useState, useEffect } from "react";
//Packages
import axios from "axios";
import DOMPurify from "dompurify"; // Sanitize the HTML just in case
const instanceURL = window.location.hostname;

const PrivacyPolicy = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  useEffect(async () => {
    const privacyPolicyGet = await axios.get(
      `/api/public_view/business_info/privacy/${instanceURL}`,
      {
        withCredentials: true,
      }
    );
    const sanitizedPrivacyPolicy = DOMPurify.sanitize(privacyPolicyGet.data.privacyPolicy);
    return setPrivacyPolicy(sanitizedPrivacyPolicy);
  }, []);

  return (
    <Container id='privacyPolicy'>
      <Row>
        <Col>
          <div dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
